import React from "react";
import { faEnvelope, faFlag, faHouse, faPhone, faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as flags from "country-flag-icons/react/3x2";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";
import InfoBox from "./InfoBox.jsx";
import CustomerLink from "../links/CustomerLink.jsx";
import HighlightText from "../highlightText/HighlightText.jsx";

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

const iconWidth = "28px";

function AwesomeIcon({ icon }) {
    return <FontAwesomeIcon icon={icon} />;
}

export function IconFn({ icon, faIcon, title }) {
    return (
        <TurnrTooltip placement={"top"} content={title}>
            <div
                style={{
                    width: iconWidth,
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                {faIcon ? <AwesomeIcon icon={faIcon} /> : icon}
            </div>
        </TurnrTooltip>
    );
}

function ValueComponent({ value }) {
    return <span style={{ overflowWrap: "break-word" }}>{value}</span>;
}

export default function EntityAddressInfoBox({ customer, entityAddress = customer?.latestAddress || customer, size = "small", customerLink = true, highlightText }) {
    const countryCode = entityAddress?.countryCode?.toUpperCase();

    let countryCodeValue = countryCode;
    try {
        countryCodeValue = countryCode && regionNames?.of(countryCode);
    } catch (e) {
        console.error("Unsupported country code", entityAddress?.countryCode);
    }
    const flagSize = size === "small" ? "18px" : "22px";

    let buyerName = (entityAddress?.firstName || entityAddress?.lastName) && (entityAddress?.firstName + " " + entityAddress?.lastName).trim();

    buyerName = <HighlightText highlightText={highlightText} text={buyerName} />;
    return (
        <InfoBox
            size={size}
            vertical={true}
            hideEmptyValues={true}
            items={[
                {
                    icon: faUser,
                    label: "Name",
                    value: customer && customerLink ? <ValueComponent value={<CustomerLink customer={customer}>{buyerName}</CustomerLink>} /> : buyerName && <ValueComponent value={buyerName} />,
                },
                {
                    icon: faEnvelope,
                    label: "Email",
                    value: <ValueComponent value={<HighlightText highlightText={highlightText} text={entityAddress?.email} />} />,
                },
                {
                    icon: faPhone,
                    label: "Phone",
                    value: <ValueComponent value={<HighlightText highlightText={highlightText} text={entityAddress?.phone || entityAddress?.phoneNumber} />} />,
                },
                {
                    icon: faHouse,
                    label: "Address",
                    value: (entityAddress?.street || entityAddress?.street2 || entityAddress?.city || entityAddress?.zip) && (
                        <ValueComponent
                            value={
                                <HighlightText
                                    highlightText={highlightText}
                                    text={([entityAddress?.street, entityAddress?.street2, entityAddress?.city].filter((v) => v).join(", ") + " " + entityAddress?.zip).trim()}
                                />
                            }
                        />
                    ),
                },
                {
                    iconFn: ({ label }) => {
                        const FlagComponent = flags[countryCode] || (() => <FontAwesomeIcon icon={faFlag} />);
                        return (
                            <IconFn
                                icon={
                                    <div style={{ width: flagSize }}>
                                        <FlagComponent />
                                    </div>
                                }
                                title={label}
                            />
                        );
                    },
                    label: "Country",
                    value: countryCodeValue ? <ValueComponent value={countryCodeValue} /> : null,
                },
            ]}
        />
    );
}
